// extracted by mini-css-extract-plugin
export default {"success":"Counter_success__dlujS","danger":"Counter_danger__xM-Uk"};